/* eslint-disable import/prefer-default-export */

import { ONBOARDING } from 'src/store/ActionTypes';

export const cancelFetchOnboardings = () => ({
  type: ONBOARDING.CANCEL_FETCH_ONBOARDINGS,
});

export const fetchOnboardings = (query) => ({
  type: ONBOARDING.FETCH_ONBOARDINGS,
  payload: query,
});

export const fetchClientOnboardingConfig = (type, scopeClientType, tenant) => ({
  type: ONBOARDING.FETCH_CLIENT_ONB_CONFIG,
  payload: {
    type,
    scopeClientType,
    tenant,
  },
});

export const uploadFiles = (files, keyPrefix, payload = {}) => ({
  type: ONBOARDING.UPLOAD_FILES,
  payload: { files, keyPrefix, payload },
});

export const stageFiles = (files) => ({
  type: ONBOARDING.STAGE_FILES,
  payload: files,
});

export const setDatasetName = (name) => ({
  type: ONBOARDING.SET_DATASET_NAME,
  payload: name,
});

export const setDatasetTag = (tag) => ({
  type: ONBOARDING.SET_DATASET_TAG,
  payload: tag,
});

export const setOnboardingType = (onboardingType) => ({
  type: ONBOARDING.SET_ONBOARDING_TYPE,
  payload: onboardingType,
});

export const triggerDetWorkflow = (payload) => ({
  type: ONBOARDING.TRIGGER_DET_WORKFLOW,
  payload,
});

/**
 * approveDetWorkflow - approve onboarding after reviewing input distribution
 * @param uploadFileId {number} - the upload file id
 * @return {{payload: object, type: string}}
 */
export const approveDetWorkflow = (uploadFileId) => ({
  type: ONBOARDING.APPROVE_DET_WORKFLOW,
  payload: uploadFileId,
});

/**
 * confirmDetWorkflow - confirm onboarding after reviewing dropped records
 * @param uploadFileId {number} - the upload file id
 * @return {{payload: object, type: string}}
 */
export const confirmDetWorkflow = (uploadFileId) => ({
  type: ONBOARDING.CONFIRM_DET_WORKFLOW,
  payload: uploadFileId,
});

/**
 * downloadDroppedEntries - download the dropped rows from an upload file
 * @param uploadFileId {number} - the upload file id
 * @return {{payload: object, type: string}}
 */
export const downloadDroppedEntries = (uploadFileId) => ({
  type: ONBOARDING.DL_DROPPED_WORKFLOW,
  payload: uploadFileId,
});

export const getUploadFile = (id) => ({
  type: ONBOARDING.GET_CUF,
  payload: id,
});

export const getOnboarding = (id) => ({
  type: ONBOARDING.GET_ONBOARDING,
  payload: id,
});

/**
 * getDataset - get a dataset
 * @param id {number} - the id of the dataset to retrieve
 * @return {{payload: object, type: string}}
 */
export const getDataset = (id) => ({
  type: ONBOARDING.GET_DATASET,
  payload: id,
});

export const fetchClientByTenant = (tenant) => ({
  type: ONBOARDING.FETCH_CLIENT_BY_TENANT,
  payload: tenant,
});

/**
 * setGridState - set the state of the table
 * @param state {object} - the next state of the table
 * @return {{payload: object, type: string}}
 */
export const setGridState = (state) => ({
  type: ONBOARDING.SET_GRID_STATE,
  payload: state,
});

export const selectGridRow = (row) => ({
  type: ONBOARDING.SELECT_GRID_ROW,
  payload: row,
});

export const deselectGridRow = (row) => ({
  type: ONBOARDING.DESELECT_GRID_ROW,
  payload: row,
});

/**
 * unset - reset the `key` to its initial value
 * @param key {string} - the state key to clear
 * @return {{payload: object, type: string}}
 */
export const unset = (key) => ({
  type: ONBOARDING.UNSET,
  payload: key,
});
